import { useState, useEffect, useCallback } from 'react';

export const useMealPlan = () => {
  const [mealPlan, setMealPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(() => {
    const userString = localStorage.getItem('user');
    return userString ? JSON.parse(userString) : null;
  });

  const fetchMealPlan = async () => {
    try {
      const userString = localStorage.getItem('user');
      const token = localStorage.getItem('token');

      if (!userString) {
        throw new Error('No user data found');
      }

      const user = JSON.parse(userString);
      

      if (!user.sub) {
        throw new Error('No user ID found');
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/mealplan/${user.sub}/meals`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch meal plan: ${response.status}`);
      }

      const data = await response.json();
      setMealPlan(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const updateMeal = async (mealId, updates) => {
    if (!user?.sub) return false;
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/mealplan/${user.sub}/meals/${mealId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(updates),
      });
      
      if (!response.ok) throw new Error('Failed to update meal');
      const updatedMealPlan = await response.json();
      setMealPlan(updatedMealPlan);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    }
  };

  const removeMeal = async (mealId) => {
    if (!user?.sub) return false;
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/mealplan/${user.sub}/meals/${mealId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (!response.ok) throw new Error('Failed to remove meal');
      const updatedMealPlan = await response.json();
      setMealPlan(updatedMealPlan);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    }
  };

  useEffect(() => {
    fetchMealPlan();
  }, []);

  return { mealPlan, loading, error, updateMeal, removeMeal };
};

export default useMealPlan; 